import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  DEFAULT_LANGUAGE,
  BLACK_LANGUAGES,
  WHITE_LANGUAGES,
} from '@/utils/langUtils';
import { getCountryLang } from '@/utils/langUtils';
import Modal from '@common/modal';

const LanguageInfoModal = () => {
  const { t, i18n } = useTranslation();
  const { language: curLang } = i18n;
  const [isShow, setIsShow] = useState(false);
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    setIsShow(!WHITE_LANGUAGES.includes(curLang));
  }, [curLang]);

  useEffect(() => {
    if (isShow) {
      const strLngs = (list) =>
        list.map((lang) => getCountryLang(t, lang)).join(t('and'));
      const title = t('unsuppoted_lang_title', {
        curLng: getCountryLang(t, curLang),
      });
      const message = t('unsuppoted_lang_detail', {
        lng: curLang,
        defaultLng: getCountryLang(t, DEFAULT_LANGUAGE),
        whiteLngs: strLngs(WHITE_LANGUAGES),
        blackLngs: strLngs(BLACK_LANGUAGES),
      });
      setTitle(title);
      setMessage(message);
    }
  }, [isShow]);

  return (
    <>
      {isShow && (
        <Modal
          info
          title={title}
          closeProps={{ onClick: () => setIsShow(false) }}
        >
          <span dangerouslySetInnerHTML={{ __html: message }} />
        </Modal>
      )}
    </>
  );
};

export default LanguageInfoModal;
